/**
 * This  modal component use for to Delete the recognise fellow
 */
import { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Modal from "../common/Modal";
import { registerMentor } from "../BecomeMentorForms/dependencies/action";
import { registerStartUp } from "../StartupForms/dependencies/action";
import { registerCohort } from "./dependencies/action";
import Button from "../common/Button";

import { useHistory } from "react-router-dom";
const SubmitForm = (props) => {
  const {
    onClose,
    deleteActivity,
    requirementId,
    onCloseafterdelete,
    currentUserId,
    submitData,
    formName,
    registerMentor,
    registerStartUp,
    registerCohort,
  } = props;
  const history = useHistory();
  useEffect(() => {
    //
    //
    // //
    // //
  }, []);

  const addFormData = () => {
    // const newformdata = JSON.stringify(submitData);
    // //
    const formData = new FormData();
    // const formData2 = new FormData();

    const industryArray = [];
    const subindustryArray = [];

    const specialityArray = [];
    const subspecializationArray = [];
    const preferedStageArray = [];
    const preferedsectormentor = [];
    const preferedfunctionsupport = [];
    const preferredStageArray = [];

    if (formName === "mentor-form") {
      submitData?.industry.map((industry) => {
        industryArray.push(industry.value);
      });
      submitData?.specialization.map((speciality) => {
        specialityArray.push(speciality.value);
      });

      submitData?.preferredStage.map((stage) => {
        preferedStageArray.push(stage.value);
      });
    } else if (formName === "startup-form") {
      submitData?.preferedsectormentor.map((stage) => {
        preferedsectormentor.push(stage.value);
      });
      submitData?.preferedfuncsupport.map((stage) => {
        preferedfunctionsupport.push(stage.value);
      });

      submitData?.preferredStage.map((stage) => {
        preferredStageArray.push(stage.value);
      });
    } else {
      submitData?.industry.map((industry) => {
        industryArray.push(industry.value);
      });
      submitData?.subindustry.map((subindustry) => {
        subindustryArray.push(subindustry.value);
      });
      submitData?.specialization.map((speciality) => {
        specialityArray.push(speciality.value);
      });
      submitData?.subspecialization.map((subspecialization) => {
        subspecializationArray.push(subspecialization.value);
      });
      submitData?.preferredStage.map((stage) => {
        preferedStageArray.push(stage.value);
      });
    }

    // //

    // const industryArray = [];

    // submitData.industry.map((industry) => {
    //   industryArray.push(industry.value);

    // })

    const mentorapplication = {
      full_name: submitData.full_name,
      country: submitData.country,
      country_name: submitData.country_name,
      email_id: submitData.email_id,
      phone_number: submitData.phone_number,
      // gender:submitData.gender,
      state: submitData.state,
      city: submitData.city,
      organization_name: submitData.organization_name,
      current_designation: submitData.current_designation,
      mentoratstartup: submitData.mentoratstartup,
      hoursperweek: submitData.hoursperweek,
      linkedinurl: submitData.linkedinurl,
      personalblogurl: submitData.personalblogurl,
      disclaimer: submitData.disclaimer,
      industry: industryArray,
      specialization: specialityArray,
      preferredStage: preferedStageArray,
      shortDesription: submitData.shortDesription,
    };

    const startupapplication = {
      appLindin_url: submitData.AppLindin_url,
      applicant_name: submitData.applicant_name,
      city: submitData.city,
      contact_no: submitData.contact_no,
      gender: submitData.gender.value,
      // gender: submitData.gender,
      country: submitData.country,
      country_name: submitData.country_name,
      current_stage: submitData.current_stage,
      curret_revenue: submitData.current_revenue,
      designation: submitData.designation,
      dpiit_no: submitData.dpiit_no,
      email_id: submitData.email_id,
      entity_name: submitData.entity_name,
      expected_outcome: submitData.expected_outcome,
      industry: submitData.industry,
      offered_startup: submitData.offered_startup,
      preffered_function: preferedfunctionsupport,
      preffered_sector: preferedsectormentor,
      preffered_stages: preferredStageArray,
      problem_solved: submitData.problem_solved,
      sector: submitData.sector,
      stage: submitData.stage,
      startup_video_url: submitData.startup_video_url,
      startupwebsite: submitData.startupwebsite,
      state: submitData.state,
      state_name: submitData.state_name,
      whyneedMentorship: submitData.whyneedMentorship,
    };

    const cohortapplication = {
      city: submitData.city,
      country: submitData.country,
      current_designation: submitData.current_designation,
      disclaimer: submitData.disclaimer,
      hoursperweek: submitData.hoursperweek,
      industry: industryArray,
      linkedinurl: submitData.linkedinurl,
      mentor_name: submitData.mentor_name,
      //  gender:submitData.gender,
      mentorenrolmentid: submitData.mentorenrolmentid,
      numberofmentors: submitData.numberofmentors,
      numberofstartups: submitData.numberofstartups,
      organization_name: submitData.organization_name,
      organization_type: submitData.organization_type?.value,
      personalblogurl: submitData.personalblogurl,
      phone_number: submitData.phone_number,
      preferred_stage: preferedStageArray,
      program_desc: submitData.program_desc,
      program_duration: submitData.program_duration,
      program_duration_text: submitData.program_duration_text,
      program_name: submitData.program_name,
      specialization: specialityArray,

      state: submitData.state,
    };
    // formData.append("newformdata", newformdata);
    formData.append(
      "application",
      JSON.stringify(
        formName === "mentor-form"
          ? mentorapplication
          : formName === "startup-form"
          ? startupapplication
          : cohortapplication
      )
    );

    formData.append(
      formName === "mentor-form"
        ? "uploadProfilePic"
        : formName === "startup-form"
        ? "upload_logo"
        : "uploadLogo",
      formName === "mentor-form"
        ? submitData.uploadProfilePic
        : formName === "startup-form"
        ? submitData.uploadLogo
        : submitData.uploadLogo
    );
    formData.append(
      formName === "mentor-form"
        ? "uploadResume"
        : formName === "startup-form"
        ? "upload_document"
        : "uploadAttach",
      formName === "mentor-form"
        ? submitData.uploadResume
        : formName === "startup-form"
        ? submitData.uploadResume
        : submitData.uploadAttach
    );
    // const application2={
    //   full_name: 'bhagyashri',
    //   country: 'india',
    // }
    // formData2.append("application2", JSON.stringify(application2));
    //
    //
    if (formName === "mentor-form") {
      registerMentor(formData).then((res) => {
        if (res) {
          if (res) {
            history.push({
              pathname: "/",
            });

            // onCloseBothModal();
            onClose();
            //
          }
        }
      });
    } else if (formName === "startup-form") {
      registerStartUp(formData).then((res) => {
        if (res) {
          // if (res) {
          //   history.push({
          //     pathname: "/",
          //   });

          //   // onCloseBothModal();
          //   onClose();
          //   //
          // }
          if (res) {
            let value = localStorage.getItem("SavedLoggedInData");
            let LoginData = JSON.parse(value);
            localStorage.removeItem("SavedLoggedInData");
            localStorage.removeItem("loggedIn");
            history.push({
              pathname: "/",
            });
            // 
            // 
            // if (LoginData.applicationStatus === "SUBMITTED") {
            //   
            //   localStorage.removeItem("SavedLoggedInData");
            //   localStorage.removeItem("loggedIn");
            // } else if (applicationStatusValue === "VERIFIED") {
            //   history.push({
            //     pathname: "/dashboard",
            //   });
            // } else {
            //   localStorage.removeItem("SavedLoggedInData");
            //   localStorage.removeItem("loggedIn");
            //   history.push({
            //     pathname: "/",
            //   });
            // }

            //Update Login Data Call view mentor profile
            // onCloseBothModal();
            // onClose();
            //
          }
        }
      });
    } else {
      registerCohort(formData).then((res) => {
        if (res) {
          if (res) {
            history.push({
              pathname: "/",
            });

            // onCloseBothModal();
            onClose();
            //
          }
        }
      });
    }
  };

  return (
    <div className="add-profile-block">
      {/* <div className="add-profile-head">
        <h2>{`Delete Activity`}</h2>
      </div> */}
      <div className="delete-text">
        {formName === "mentor-form"
          ? "Do you want to continue to become a Mentor?"
          : formName === "startup-form"
          ? "Do you want to continue to become a Startup?"
          : "Do you want to continue to become a Cohort?"}
      </div>
      <div className="add-profile-footer">
        <Button
          onClick={() => {
            addFormData();
            // //
          }}
          text="Submit"
          className="submit"
        />
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {};
};
export default connect(mapStateToProps, {
  registerMentor,
  registerStartUp,
  registerCohort,
})(withRouter(Modal(SubmitForm)));

// export default withRouter(Modal(SubmitCohortForm));
